import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import CardFormFonts from './CardFormFont'
import CardFormStyle from './CardFormStyle'
import type { CardFormBrandType, CardBrandForms } from './cardTypes'

const FORM_MAP: CardBrandForms = {
  [BrandFormEnum.STYLE]: CardFormStyle,
  ...CardFormFonts,
}

const CardFormBrand: CardFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(CardFormBrand) as typeof CardFormBrand
